<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ page.nome }}</h4>
    <button type="button" (click)="bsModalRef.hide();" class="close pull-right button" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <h5>
        Olá {{usuario.nome}}.<br>
        Por favor, informe um email válido para a atualização do seu cadastro.
      </h5>
    </div>
    <div class="container">
      <form [formGroup]="formEmail">
        <div class="row">
          <div class="form-group col-md-12">
            <label class="col-form-label" for="email">Email*</label>
            <input type="text" class="form-control" formControlName="email" id="email">
            <div *ngIf="verifyValid('email')" class="alert alert-warning">
              <div [hidden]="!verifyReq('email')">
                Campo obrigatório.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary button" data-dismiss="modal"
                  (click)="bsModalRef.hide();">Fechar
          </button>
          <button (click)="updateEmail()" class="btn btn-primary button">
            {{ page.botao }}
          </button>
        </div>

      </form>
      
    </div>
  </div>
  <ngx-loading [show]="loaders.loading"></ngx-loading>
</div>

<app-cidades *ngIf="loaders.loadCidades" (selectCidade)="onSelectCidade($event)" #buscaCidades></app-cidades>